import set from 'lodash/set';

import { getNowISO } from './helper';
import { convert } from './v4';
import { identify } from './v4.calls';
import psProperties from './v4.ps-properties';

const conversionProperties = ['email', 'phone'];

const visitorProperties: Partial<Record<string, string>> = {};

// Expose for E2E testing — stripped from production builds by Vite
if (import.meta.env.DEV && typeof window !== 'undefined') {
    (window as any).__visitorProperties = visitorProperties;
}

export const initializeVisitorProperties = (sessionId: string) => {
    // Clear existing properties to start fresh
    Object.keys(visitorProperties).forEach((key) => delete visitorProperties[key]);

    const key = `${sessionId}_user_traits`;
    const value = window.sessionStorage.getItem(key);

    if (value === null) {
        visitorProperties[psProperties.firstSeenAt] = getNowISO();

        return;
    }

    try {
        const obj = JSON.parse(value);

        const keys = [
            psProperties.startPage,
            psProperties.startSlug,
            psProperties.firstSeenAt,
        ] as const;

        for (const key of keys) {
            const value = obj[key];

            if (typeof value !== 'string') {
                continue;
            }

            visitorProperties[key] = value;
        }
    } catch (error) {
        console.error(`Failed to parse JSON from Session Storage key ${key}:`, error);
    }

    if (!visitorProperties[psProperties.firstSeenAt]) {
        visitorProperties[psProperties.firstSeenAt] = getNowISO();
    }
};

// that object is dynamic, it holds one or more question / form information
export const updateVisitorProperties = (obj: { [key: string]: unknown }) => {
    Object.keys(obj).forEach((key) => {
        set(visitorProperties, key, obj[key]);
    });

    conversionProperties.forEach((conversionProperty) => {
        if (visitorProperties[conversionProperty] && !visitorProperties[psProperties.isConverted]) {
            set(visitorProperties, psProperties.isConverted, true);
            set(visitorProperties, psProperties.convertedAt, getNowISO());
            convert();
        }
    });
    set(visitorProperties, psProperties.lastSeenAt, getNowISO());

    identify(visitorProperties);
};
export const getVisitorProperties = () => visitorProperties;
